import type { ReactNode } from "react";

import { cn } from "@/lib/cn";

/**
 * A key, drawn as a key.
 *
 * The same small chip the search button prints its shortcut on, on a sunken
 * ground so that it shows on a white panel as well as on the grey frame.
 */
export function Kbd({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <kbd
      className={cn(
        "inline-grid min-w-6 place-items-center rounded-xs bg-surface-sunken px-1.5 py-0.5",
        "font-sans text-2xs font-medium text-fg-muted ring-1 ring-inset ring-line",
        className,
      )}
    >
      {children}
    </kbd>
  );
}
